<template>
  <div class="container signup text-center">
    <div>
      <div v-if="canRegister" class="movie-list-header mt-0">
        <h1>Create your account</h1>
      </div>
      <template v-if="canRegister">
        <p class="text-white">Create an account to join {{ invite.listName }}.</p>
        <SignUpForm :inviteToken="inviteToken"></SignUpForm>
      </template>
      <div v-else class="movie-list-header mt-0">
        <h1>{{ statusHeading }}</h1>
        <p v-if="accountCreationAllowed && !loading" class="text-white">Open a valid invite link from your group to create an account.</p>
        <button v-if="previewFailed" class="btn btn-yellow" type="button" @click="loadInvite">Try again</button>
        <p class="text-white">
          Already have an account?
          <router-link :to="{ name: 'Login', query: redirectQuery }">Log in to continue</router-link>
        </p>
      </div>
      <p v-if="canRegister" class="text-white mt-3">
        Already have an account?
        <router-link :to="{ name: 'Login', query: redirectQuery }">Sign in</router-link>
      </p>
    </div>
  </div>
</template>

<script>
import SignUpForm from "@/components/SignUpForm.vue";
import InviteService from "@/services/InviteService";
import { inviteTokenFromRedirect } from "@/utilities/invite";
import { accountCreationAllowed } from "@/config/accountCreation";

export default {
  name: "SignUp",
  components: {
    SignUpForm,
  },
  data() {
    return { invite: null, loading: true, previewFailed: false };
  },
  computed: {
    inviteToken() {
      return inviteTokenFromRedirect(this.$route.query.redirect);
    },
    canRegister() {
      return this.accountCreationAllowed && !this.loading && Boolean(this.invite);
    },
    statusHeading() {
      if (!this.accountCreationAllowed) return "Account creation is currently closed for private beta.";
      if (this.loading) return "Checking your invite...";
      if (this.previewFailed) return "We couldn't check your invite";
      return "You need an invite to create an account";
    },
    accountCreationAllowed() {
      return accountCreationAllowed;
    },
    redirectQuery() {
      return this.$route.query.redirect ? { redirect: this.$route.query.redirect } : {};
    },
  },
  watch: {
    inviteToken() {
      this.loadInvite();
    },
  },
  created() {
    this.loadInvite();
  },
  methods: {
    async loadInvite() {
      const token = this.inviteToken;
      this.invite = null;
      this.previewFailed = false;
      this.loading = true;
      try {
        if (this.accountCreationAllowed && token) {
          const invite = await InviteService.getPreview(token);
          if (token === this.inviteToken) this.invite = invite;
        }
      } catch (error) {
        if (token === this.inviteToken) this.previewFailed = !error.response || error.response.status !== 404;
      } finally {
        if (token === this.inviteToken) this.loading = false;
      }
    },
  },
};
</script>

<style scoped>
.signup {
  min-height: calc(100vh - 136px);
  display: flex;
  align-items: center;
  justify-content: center;
}
</style>
